if (!customElements.get('collection-commerce-hub')) {
  class CollectionCommerceHub extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-hub-search]');
      this.results = this.querySelector('[data-hub-results]');
      this.status = this.querySelector('[data-hub-status]');
      this.brandCards = this.querySelector('[data-hub-brand-cards]');
      this.typeFilters = this.querySelector('[data-hub-type-filters]');
      this.typeWrap = this.querySelector('[data-hub-type-wrap]');
      this.nativeGrid = document.querySelector('.main-collections-product');
      this.products = [];
      this.activeBrand = '';
      this.activeVendors = [];
      this.activeType = '';
      this.input.addEventListener('input', () => this.render());
      this.querySelectorAll('[data-hub-clear]').forEach((button) => button.addEventListener('click', () => this.clear()));
      this.load();
    }

    async load() {
      try {
        const response = await fetch(this.dataset.endpoint, { credentials: 'same-origin' });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const payload = await response.json();
        this.products = payload.products || [];
        this.buildBrandCards();
        this.applyUrlState();
        this.status.textContent = `${this.products.length} productos en esta categoría`;
      } catch (error) {
        this.status.textContent = 'La navegación contextual no está disponible temporalmente.';
      }
    }

    preferredGroups() {
      const groups = {
        accesorios: [['Logitech', ['Logitech', 'Logitech G']], ['Genius', ['Genius']], ['Basik', ['Basik', 'Basik Tech']], ['Trust', ['Trust']], ['Otras marcas', []]],
        auriculares: [['Logitech', ['Logitech', 'Logitech G']], ['Genius', ['Genius']], ['Trust', ['Trust']], ['Otras marcas', []]],
        redes: [['TP-Link', ['TP-Link']], ['Mercusys', ['Mercusys']], ['Otras marcas', []]],
        'camaras-y-seguridad': [['Tapo / TP-Link', ['Tapo', 'TP-Link', 'TP-Link Tapo']], ['EZVIZ', ['EZVIZ']], ['Dahua', ['Dahua']], ['Otras marcas', []]],
        gaming: [['Logitech G', ['Logitech G', 'Logitech']], ['Trust Gaming', ['Trust']], ['Otras marcas', []]],
        'smart-home': [['Tapo / TP-Link', ['Tapo', 'TP-Link', 'TP-Link Tapo']], ['Otras marcas', []]]
      };
      return groups[this.dataset.collectionHandle] || [];
    }

    logos() {
      try { return JSON.parse(this.querySelector('[data-hub-brand-assets]').textContent); } catch (_) { return {}; }
    }

    buildBrandCards() {
      const vendors = [...new Set(this.products.map((product) => (product.vendor || '').trim()).filter(Boolean))];
      const configured = this.preferredGroups();
      const assigned = new Set(configured.flatMap(([, values]) => values));
      this.groups = configured.map(([label, values]) => [label, values.length ? values : vendors.filter((vendor) => !assigned.has(vendor))]);
      const logoMap = this.logos();
      this.brandCards.innerHTML = '';
      this.groups.forEach(([label, values]) => {
        const products = this.products.filter((product) => values.includes((product.vendor || '').trim()));
        if (!products.length) return;
        const representative = products.find((product) => product.images && product.images.length) || products[0];
        const productImage = representative.images && representative.images[0] ? representative.images[0].src : '';
        const logo = logoMap[label] || '';
        const card = document.createElement('a');
        card.className = 'collection-commerce-hub__brand-card';
        card.href = this.stateUrl(label);
        card.dataset.brand = label;
        card.innerHTML = `<span class="collection-commerce-hub__brand-visual">${productImage ? `<img src="${productImage}" alt="" loading="lazy" width="600" height="420">` : ''}</span><span class="collection-commerce-hub__brand-copy">${logo ? `<img class="collection-commerce-hub__brand-logo" src="${logo}" alt="${label}" loading="lazy">` : `<span class="collection-commerce-hub__brand-wordmark">${label}</span>`}<strong>${label}</strong><small>${products.length} producto${products.length === 1 ? '' : 's'}</small></span>`;
        card.addEventListener('click', (event) => {
          event.preventDefault();
          this.selectBrand(label, values, true);
        });
        this.brandCards.appendChild(card);
      });
    }

    applyUrlState() {
      const label = new URLSearchParams(location.search).get('brand');
      if (!label) return;
      const group = (this.groups || []).find(([name]) => name === label);
      if (group) this.selectBrand(group[0], group[1], false);
    }

    selectBrand(label, vendors, updateUrl) {
      this.activeBrand = label;
      this.activeVendors = vendors;
      this.activeType = '';
      this.brandCards.querySelectorAll('[data-brand]').forEach((card) => card.setAttribute('aria-current', card.dataset.brand === label ? 'true' : 'false'));
      this.buildTypeFilters();
      if (updateUrl) history.replaceState({}, '', this.stateUrl(label));
      this.render(true);
      this.typeWrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    buildTypeFilters() {
      const counts = new Map();
      this.products.filter((product) => this.activeVendors.includes(product.vendor)).forEach((product) => {
        const value = (product.product_type || '').trim();
        if (value) counts.set(value, (counts.get(value) || 0) + 1);
      });
      this.typeFilters.innerHTML = '';
      [...counts.entries()].sort((a, b) => a[0].localeCompare(b[0], 'es')).forEach(([value, count]) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'collection-commerce-hub__pill';
        button.textContent = `${value} (${count})`;
        button.setAttribute('aria-pressed', 'false');
        button.addEventListener('click', () => {
          this.activeType = this.activeType === value ? '' : value;
          this.typeFilters.querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', String(item === button && this.activeType === value)));
          this.render(true);
        });
        this.typeFilters.appendChild(button);
      });
      this.typeWrap.hidden = !this.typeFilters.children.length;
    }

    clear() {
      this.input.value = '';
      this.activeBrand = '';
      this.activeVendors = [];
      this.activeType = '';
      this.brandCards.querySelectorAll('[data-brand]').forEach((card) => card.removeAttribute('aria-current'));
      this.typeFilters.innerHTML = '';
      this.typeWrap.hidden = true;
      this.results.hidden = true;
      this.results.innerHTML = '';
      if (this.nativeGrid) this.nativeGrid.style.display = '';
      const cleanUrl = new URL(location.href);
      cleanUrl.searchParams.delete('brand');
      history.replaceState({}, '', `${cleanUrl.pathname}${cleanUrl.search}`);
      this.status.textContent = `${this.products.length} productos en esta categoría`;
    }

    money(value) {
      return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(Number(value || 0));
    }

    stateUrl(label) {
      const url = new URL(location.href);
      url.searchParams.set('brand', label);
      return `${url.pathname}${url.search}`;
    }

    render(force = false) {
      const query = this.input.value.trim().toLocaleLowerCase('es');
      if (!query && !this.activeVendors.length && !this.activeType && !force) return this.clear();
      const matches = this.products.filter((product) => {
        const haystack = `${product.title} ${product.vendor || ''} ${product.product_type || ''} ${(product.variants || []).map((variant) => variant.sku || '').join(' ')}`.toLocaleLowerCase('es');
        return (!query || haystack.includes(query)) && (!this.activeVendors.length || this.activeVendors.includes(product.vendor)) && (!this.activeType || product.product_type === this.activeType);
      });
      this.results.hidden = false;
      if (this.nativeGrid) this.nativeGrid.style.display = 'none';
      this.results.innerHTML = matches.length ? matches.slice(0, 24).map((product) => {
        const variant = (product.variants || []).find((item) => item.available) || (product.variants || [])[0] || {};
        const image = product.images && product.images[0] ? `<img src="${product.images[0].src}" alt="" loading="lazy" width="480" height="480">` : '';
        const url = `/products/${product.handle}`;
        const compareAt = Number(variant.compare_at_price || 0) > Number(variant.price || 0) ? `<s>${this.money(variant.compare_at_price)}</s>` : '';
        return `<article class="collection-commerce-hub__card"><a class="collection-commerce-hub__media" href="${url}">${image}</a><div class="collection-commerce-hub__body"><p class="collection-commerce-hub__vendor">${product.vendor || ''}</p><h3 class="collection-commerce-hub__title"><a href="${url}">${product.title}</a></h3><p class="collection-commerce-hub__price">${this.money(variant.price)} ${compareAt}</p><a class="collection-commerce-hub__cta" href="${url}">${variant.available ? 'Ver producto' : 'Consultar disponibilidad'}</a></div></article>`;
      }).join('') : '<p class="collection-commerce-hub__empty">No encontramos coincidencias dentro de esta categoría.</p>';
      const scope = this.activeBrand ? ` en ${this.activeBrand}` : ` dentro de ${this.dataset.collectionTitle}`;
      this.status.textContent = `${matches.length} resultado${matches.length === 1 ? '' : 's'}${scope}`;
    }
  }
  customElements.define('collection-commerce-hub', CollectionCommerceHub);
}
